import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Textarea } from '../../../../../../../../CommonComponents/OPL/Textarea/Textarea';
import { MarginProps } from '../../../../../../../../theme/styledProps';

interface Props extends MarginProps {
  bucketIndex: number;
}

export const Description = ({ bucketIndex, ...rest }: Props) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <Textarea
      {...register(`buckets.${bucketIndex}.description`)}
      maxLength={250}
      label="Description"
      formVariant={errors?.buckets?.[bucketIndex]?.description?.message ? 'error' : undefined}
      helperText={errors?.buckets?.[bucketIndex]?.description?.message || 'Max. 250 characters'}
      rows={6}
      {...rest}
    />
  );
};
